'use strict';

(function () {
  'use strict';

  angular.module('vnext').directive('msUploadImage', uploadImage);

  uploadImage.$inject = ['$timeout', 'uploadImageSvc', 'alertSvc', 'imgixDimensions'];

  function uploadImage($timeout, uploadImageSvc, alertSvc, imgixDimensions) {
    var directive = {
      link: link,
      restrict: 'AE',
      require: 'ngModel',
      templateUrl: 'vnext/templates/image-upload.html',
      scope: {
        ngModel: '='
      }
    };
    return directive;

    function link(scope, element, attrs, ngModel) {
      scope.setModel = setModel;

      function setModel(val) {
        ngModel.$setViewValue(val);
        $timeout(function () {
          scope.processing = false;
        });
      }
      var file = element.find('#file');
      file.bind('change', function (e) {
        var file = e.target.files[0];
        var filename = e.target.value;
        scope.processing = true;
        uploadImageSvc.upload(file, filename).then(function (data) {
          // once it's uploaded, let's get it cached before ending the loading animation
          var i = new Image();
          i.src = data + imgixDimensions.medSquare;
          i.onload = function () {
            setModel(data);
            e.target.value = null;
          };
          i.onerror = function () {
            alertSvc.error('Failed to upload image', e);
            setModel(undefined);
            e.target.value = null;
          };
        }, function (e) {
          setModel(undefined);
          alertSvc.error('Failed to upload image', e);
          e.target.value = null;
        });
      });
    }
  }
})();